<template>
  <div class="layout">
    <app-header ref="appHeader" :clean="true" />

    <div class="sign">
      <el-row type="flex" justify="space-between">
        <el-col class="sign-visual">
          <unit-loader v-if="isMt(banners)" type="block" color="white" />
          <div v-else v-swiper:bannerSwiper="swiperOption" ref="bannerSwiper">
            <div class="swiper-wrapper">
              <figure v-for="(banner, index) in banners" :key="index" class="swiper-slide">
                <img
                  class="sign-visual__image"
                  :src="banner.image.source"
                  width="640" height="1200"
                  :alt="banner.image.text" />
                <figcaption>
                  <strong>{{ banner.title }}</strong>
                  <div v-html="banner.contents" />
                </figcaption>
              </figure>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </el-col>
        <el-col class="sign-content">
          <div class="sign-wrap">
            <router-view />
            <footer>
              <p class="copy">{{ $t('footer.copyright') }}</p>
            </footer>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import AppHeader from 'views/components/app-header';
  import Language from 'views/components/language';
  import Logo from 'views/components/logo';
  import {mapGetters} from 'vuex';

  export default {
    title: 'Sign Layout',

    components: {
      AppHeader,
      Language,
      Logo,
    },

    data() {
      return {
        banners: [],
        swiperOption: {
          autoplay:{
            delay: 10000
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className} swiper-pagination-bullet-custom"><span>0${index + 1}</span></span>`
            }
          },
          loop:true,
          effect:'fade'
        }
      }
    },
    mounted() {
      this.getBanner();
    },
    computed: {
      stickyHeader () {
        return this.$store.getters.stickyHeader;
      },
      floatingHeader () {
        return this.$store.getters.floatingHeader;
      },
      transparentTop () {
        return !this.openLayers && this.$store.getters.visualHeight > this.scrollTop + 85
      }
    },
    methods: {
      isOpened () {
        this.$emit('popoverOpened',this.isPopoverOpened)
      },
      getBanner() {
        this.$http.get('/contents/v1/banner/signin').then((response) => {
          this.banners = response.data;
        });
      }
    }
  }
</script>

<style src="./style.scss" lang="scss" scoped></style>
